import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as ForgotPasswordActions from "../../store/forgotPasswordService/actions";
import { useForm } from "react-hook-form";
import NeedHelp from "./NeedHelp";
import { PATTERNS } from "../../util/patterns";
import { ApplicationState } from "../../store";
import * as Service from "../../store/service";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const ForgotPassword = (props: any) => {
    const [errorMSg, setErrorMSg] = useState("");
    const [logoHTML, setLogoHTML] = useState("");
    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });
    const isNewResetFlow = true;
    const [state, setState] = useState({ loading: false });
    const [hasResetEmailSent, setHasResetEmailSent] = useState(false);
    const dispatch = useDispatch();
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig());
    const submitEmailOld = (email: string, history: any) => dispatch(ForgotPasswordActions.actionCreators.submitEmail(email, history));
    const resetEmail = () => dispatch(ForgotPasswordActions.actionCreators.resetEmail());
    const isSecurityQueNotAvailable = useSelector((state: ApplicationState) =>
        state.forgotPasswordState && state.forgotPasswordState.isSecurityQueNotAvailable ? state.forgotPasswordState.isSecurityQueNotAvailable : false
    );
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const allowLoginWithUserName: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            ? state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            : false
    );
    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const businessPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.businessPhoneNumber
            ? state.configurationState.configuration.partnerConfig.businessPhoneNumber
            : ""
    );
    const brandingLogo: string = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.brandingOption &&
        state.configurationState.configuration.partnerConfig.brandingOption.imagePath
            ? state.configurationState.configuration.partnerConfig.brandingOption.imagePath
            : ""
    );
    const partnerID = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerId
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const redirectToDomain = () => {
        const query = new URLSearchParams(props.location.search);
        const redirectMessage = query.get("RedirectMessage");
        if (redirectMessage) {
            setErrorMSg(redirectMessage);
        }
    };

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });

    useEffect(() => {
        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, 'text/html');
            let imgElements = parsedDoc.querySelectorAll('img');
            imgElements?.forEach(img => {
                if (!img.hasAttribute('alt')) {
                    img.setAttribute('alt', 'Logo');
                }
            });
            footerLogoHTML = parsedDoc.documentElement.innerHTML;
            setLogoHTML(footerLogoHTML);
        }
        resetEmail();
        redirectToDomain();
        requesPartnerConfig();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (isOneTrustPartner) {
            var CookiePrefFooterLink = document.getElementById("cookie-pref-footer-link");
            if (CookiePrefFooterLink != null) {
                CookiePrefFooterLink.remove();
            }
        }
    }, []);

    const submitEmail = (email: string, history: any) => {
        if (isNewResetFlow) {
            setState({ ...state, loading: true });
            Service.generatePasswordResetLink(email, partnerID!).then((data) => {
                setHasResetEmailSent(true);
                setState({ ...state, loading: false });
            });
        } else {
            submitEmailOld(email, history);
        }
    };

    const redirectSSO = (data: any) => {
        setState({ ...state, loading: true });
        Service.getAuthenticationType({ email: data.email })
            .then((res) => {
                if (res.userAuthStatus !== "SSO") {
                    submitEmail(data.email, props.history);
                }
                if (res.userAuthStatus === "SSO") {
                    window.location.replace(
                        `/${res.ssoRedirectURL}?brand=sontiq&supportPhone=${businessPhoneNumber}&email=${encodeURIComponent(data.email)}&logo=${encodeURIComponent(
                            brandingLogo
                        )}&action=forgot-password`
                    );
                }
            })
            .catch((err) => {
                setState({ ...state, loading: false });
                submitEmail(data.email, props.history);
            });
    };

    const onSubmit = (data: any) => {
        redirectSSO(data);
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                {tLang("forgotPassword.header")}
                            </h1>
                        </div>
                    </div>

                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            {isSecurityQueNotAvailable && (
                                <div className="notice-container status-warning notice-xs" role="alert" aria-atomic="true">
                                    <span role="img" aria-label="info-circle" className="notice-icon">
                                        <em className="las la-exclamation-circle"></em>
                                    </span>
                                    <div className="notice-message">{tLang("forgotPassword.securityQuestionError")}</div>
                                    <div className="notice-description">
                                        {tLang("forgotPassword.securityQuestionDescription")} <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>.
                                    </div>
                                </div>
                            )}
                            <div className="box box-has-shadow box-xs offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("forgotPassword.header")}</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        {hasResetEmailSent ? (
                                            <p>
                                                {tLang("forgotPassword.confirmationMessage")} <br /> <br />
                                                {tLang("forgotPassword.contactMessage")} <a href={"tel:" + partnerPhoneNumber}>{partnerPhoneNumber}</a>.
                                            </p>
                                        ) : allowLoginWithUserName ? (
                                            <p>{tLang("forgotPassword.paragraphEmailAndUsername")}</p>
                                        ) : (
                                            <p>{tLang("forgotPassword.paragraphEmail")}</p>
                                        )}
                                    </div>
                                </div>
                                <div className={state.loading ? "box-content loading" : "box-content"}>
                                    {!hasResetEmailSent && (
                                        <form id="form-forgot-password" onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-row">
                                                <div className="form-label col-xs-12 col-no-gutter">
                                                    {allowLoginWithUserName ? (
                                                        <label htmlFor="email">{tLang("forgotPassword.lablEmailOrUser")}</label>
                                                    ) : (
                                                        <label htmlFor="email">{tLang("forgotPassword.labelEmail")}</label>
                                                    )}
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        type="text"
                                                        id="email"
                                                        className={errors.email ? "status-error inputbox" : "inputbox"}
                                                        name="email"
                                                        ref={register({
                                                            required: true,
                                                            pattern: allowLoginWithUserName ? PATTERNS.USERNAME_OR_EMAIL.pattern : PATTERNS.EMAIL.pattern,
                                                        })}
                                                    />
                                                    {errors.email && errors.email.type === "required" && (
                                                        <span className="form-error">
                                                            {allowLoginWithUserName ? (
                                                                <p>{tLang("forgotPassword.validations.emailOrUsernameRequired")}</p>
                                                            ) : (
                                                                <p>{tLang("forgotPassword.validations.emailRequired")}</p>
                                                            )}
                                                        </span>
                                                    )}
                                                    {errors.email && errors.email.type === "pattern" && (
                                                        <span className="form-error">
                                                            {allowLoginWithUserName ? (
                                                                <p>{tLang("forgotPassword.validations.emailOrUsernameValid")}</p>
                                                            ) : (
                                                                <p>{tLang("forgotPassword.validations.emailValid")}</p>
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="margin-bottom-s"></div>

                                            {errorMSg && errorMSg.length > 0 && (
                                                <div className="form-row display-block">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <span className="required">{errorMSg}</span>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="form-row row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <button
                                                        type="submit"
                                                        className="btn-default btn-primary btn-min-width"
                                                        onClick={() => window.addToDataLayer({ event: "Submit Email Address" })}
                                                    >
                                                        <span className="btn-text">{tLang("forgotPassword.contBtn")}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="form-row row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-link btn-no-padding btn-no-border"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Back to Login" });
                                                            props.history.push("/");
                                                        }}
                                                    >
                                                        <span className="btn-text">{tLang("forgotPassword.backBtn")}</span>
                                                    </button>
                                                </div>
                                            </div>

                                            {!isLife360PartnerId && (
                                                <>
                                                    <div className="line-divider margin-vertical-l"></div>

                                                    <NeedHelp />
                                                </>
                                            )}
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
            </div>
        </React.Fragment>
    );
};

export default ForgotPassword;
